<script setup lang="ts">
import { computed } from 'vue'
import { useCampusStore } from '@/stores/campus'
import { useGuideMode } from '@/composables/useGuideMode'
import AvatarImage from '@/components/common/AvatarImage.vue'
import { Loader2 } from 'lucide-vue-next'

const campusStore = useCampusStore()
const { backToFellowUrl, guideFellowDisplayName } = useGuideMode()

const avatarSrc = computed(() => campusStore.guideFellowDisplay?.avatarUrl ?? null)
</script>

<template>
  <div
    class="sticky top-12 z-30 border-b border-cosmicPurple/20 bg-gradient-to-r from-cosmicPurple/[0.08] via-violet-50/40 to-cosmicPurple/[0.06]"
  >
    <div class="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-3 sm:px-6">
      <div class="flex min-w-0 flex-1 items-center gap-3">
        <div
          class="relative flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-full border-2 border-white bg-gray-100 shadow-sm ring-1 ring-cosmicPurple/20"
        >
          <Loader2
            v-if="campusStore.guideFellowDisplayLoading && !avatarSrc"
            class="h-5 w-5 animate-spin text-cosmicPurple"
          />
          <AvatarImage
            v-else
            :src="avatarSrc"
            :alt="guideFellowDisplayName"
            size="xl"
          />
        </div>
        <div class="min-w-0">
          <p class="truncate text-sm font-semibold text-gray-900">
            {{ guideFellowDisplayName }}
          </p>
          <p class="text-xs text-gray-600">
            You’re editing this fellow’s Campus — curriculum, tracks, and tasks below are theirs.
          </p>
        </div>
      </div>
      <router-link
        :to="backToFellowUrl"
        class="shrink-0 text-sm font-medium text-cosmicPurple hover:underline"
      >
        Back to fellow
      </router-link>
    </div>
  </div>
</template>
